import React from "react";
import PageLayout from "../components/PageLayout";
import { useTranslation } from "../i18n/LanguageContext";

function Careers() {
  const { t } = useTranslation();

  return (
    <PageLayout
      title={t("careers.title", "Careers & Partnerships")}
      subtitle={t("careers.subtitle", "Build something amazing with us")}
    >
      <div className="space-y-8">
        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("careers.hiringTitle", "We're Not Hiring Yet")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "careers.hiringText",
              "PartyBuddy is in early stages and we're currently a small, focused team. However, we're always interested in hearing from passionate people who want to help us build the future of event discovery."
            )}
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("careers.developersTitle", "For Developers")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "careers.developersText1",
              "Are you a developer interested in what we're building? We'd love to hear about your ideas for features, integrations, or how PartyBuddy could fit into your projects."
            )}
          </p>
          <p className="mb-4 text-slate-300">
            {t("careers.developersText2", "Reach out to us at:")}
          </p>
          <p className="text-blue-400">
            <a
              href="mailto:developers@partybuddy.app"
              className="transition hover:text-blue-300"
            >
              developers@partybuddy.app
            </a>
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("careers.partnersTitle", "For Partners")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "careers.partnersText",
              "We're interested in strategic partnerships with venues, event promoters, festivals, and platforms that share our vision of connecting people through experiences."
            )}
          </p>
          <p className="text-blue-400">
            <a
              href="mailto:business@partybuddy.app"
              className="transition hover:text-blue-300"
            >
              business@partybuddy.app
            </a>
          </p>
        </section>

        <section>
          <h2 className="mb-4 text-2xl font-semibold text-blue-300">
            {t("careers.journeyTitle", "Follow Our Journey")}
          </h2>
          <p className="mb-4 text-slate-300">
            {t(
              "careers.journeyText",
              "Want to stay updated on what we're building? Follow us on social media or subscribe to our updates to be among the first to know when we're looking for talent and partnerships."
            )}
          </p>
        </section>
      </div>
    </PageLayout>
  );
}

export default Careers;
